import React, { useState } from "react";
import DashboardKpiStatus from "components/DashboardKpiStatus";
import { overviewChartPalette } from "styles/theme";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import { CiCalendar } from "react-icons/ci";
import { FaRupeeSign } from "react-icons/fa";
import LeaseListPopUp from "./leaseListPopUp";
import DealsListPopUp from "./dealListPopup";


const LeaseKpi = ({ data, isError, isLoading }) => {
  const [status, setStatus] = useState("")
  const [isPopup, setIsPopup] = useState(false)
  const [isDealPopup, setIsDealPopup] = useState(false)
  const [header, setHeader] = useState("");

  const handleClick = (label, status) => {
    const filters = {};

    if (label === "Deals Won") {
      setIsDealPopup(true);
      setHeader(label);
    } else {
      if (status) {
        filters.CurrentStage = status;
      }
      setStatus(filters);
      setHeader(label);
      setIsPopup(true);
    };
  }
   const handleDealClose = () => {
    setIsDealPopup(false);
  };


  const handleClose = () => {
    setIsPopup(false);
  };

  const kpis = [
    {
      key: "totalLeadsGenerated",
      label: "Total Leads Generated",
      value: data?.totalLeadsGenerated ?? "-",
      bg: "#FFF4DE",
      iconBg: overviewChartPalette.amber,
      // status: "totalLeads"
    },
    {
      key: "activeLeads",
      label: "Active Leads",
      value: data?.activeLeads ?? "-",
      bg: "#E1F0FF",
      iconBg: overviewChartPalette.indigo,
      status: "Active"
    },
    {
      key: "leadsLost",
      label: "Leads Lost",
      value: data?.leadsLost ?? "-",
      bg: "#FFE2E5",
      iconBg: overviewChartPalette.coral,
      status: "Lost"
    },
    {
      key: "dealsWon",
      label: "Deals Won",
      value: data?.dealsWon ?? "-",
      bg: "#DCFCE7",
      iconBg: overviewChartPalette.teal,
      // status: "Won"
    },
    {
      key: "dealsWonPercentage",
      label: "Deals Won %",
      value: data?.dealsWonPercentage ?? "-",
      bg: "#FFF4DE",
      iconBg: overviewChartPalette.violet,
      type: "percentage",
    },
  ];

  const clickable = [
    "Total Leads Generated",
    "Active Leads",
    "Leads Lost",
    "Deals Won"
  ];

  return (
    <>
      <Box
        elevation={0}
        sx={{
          borderRadius: "3px",
          border: "1px solid #eef0f4",
          backgroundColor: "#FFFFFF",
          width: "100%",
          boxSizing: "border-box",
          p: "20px 20px 20px 20px",
          maxHeight: { xs: "auto", md: "316px" },
        }}
      >
        <Typography
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 600,
            fontSize: "15px",
            lineHeight: "21px",
            letterSpacing: "0px",
            color: "#05004E",
          }}
        >
          Leasing Intelligence
        </Typography>
        <Typography
          sx={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px",
            letterSpacing: "0px",
            color: "#737791",
            mb: 2,
          }}
        >
          Tracks leasing pipeline, deal progress, and commercial performance.
        </Typography>
        {isLoading && (
          <Box
            sx={{
              minHeight: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={32} />
          </Box>
        )}
        {isError && (
          <Box
            sx={{
              minHeight: "100px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: 2,
            }}
          >
            <Typography
              sx={{
                fontFamily: "Outfit, sans-serif",
                fontSize: "14px",
                color: "#FF4F8B",
                textAlign: "center",
              }}
            >
              Failed to load data. Please try again.
            </Typography>
          </Box>
        )}
        {!isError && !isLoading && <Grid
          container
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))",
            gap: 1.25,
            width: "100%",
            "& > .MuiGrid-root": { minWidth: 0, width: "auto", maxWidth: "none" },
            "& .MuiCard-root": { transition: "border-color 140ms ease, box-shadow 140ms ease, transform 140ms ease" },
            "& .MuiCard-root:hover": { borderColor: "#CBD5E1", boxShadow: "0 4px 12px rgba(15, 23, 42, 0.08)", transform: "translateY(-1px)" },
          }}
        >
          {kpis?.map((item) => (
            <Grid
              xs={12}
              sm={6}
              md={12 / 7}
              key={item.label}
              sx={{ minWidth: 0 }}
            >
              <Card
                elevation={0}
                onClick={() =>
                  item.label === "Total Leads Generated" ||
                    item.label === "Active Leads" ||
                    item.label === "Leads Lost" ||
                    item.label === "Deals Won"
                    ? handleClick(item.label, item.status)
                    : undefined
                }
                sx={{
                  height: "128px",
                  position: "relative",
                  // width: { minWidth: "200px", minWidth: "100%" },
                  cursor: clickable.includes(item.label)
                    ? "pointer"
                    : "default",
                  borderRadius: "3px",
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #E2E8F0",
                  borderBottom: `3px solid ${item.iconBg}`,
                }}
              >
                <CardContent sx={{ gap: 1, p: 1.25, pt: 1.25 }}>
                  <Avatar
                    sx={{
                      width: 30,
                      height: 30,
                      backgroundColor: item.iconBg,
                      fontSize: 18,
                      fontWeight: 700,
                    }}
                  >
                    {item.type === "rupee" ? <FaRupeeSign /> : <CiCalendar />}
                  </Avatar>
                  <DashboardKpiStatus color={item.iconBg} />

                  <>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "13px",
                        mt: "4px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: "Outfit, sans-serif",
                          fontWeight: 600,
                          fontSize: "16px",
                          lineHeight: "21px",
                          color: "#151D48",
                        }}
                      >
                        {item.value}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontFamily: "Outfit, sans-serif",
                        fontWeight: 500,
                        lineHeight: "16px",
                        fontSize: "12px",
                        letterSpacing: "0px",
                        color: "#425166",
                        mt: "4px",
                      }}
                    >
                      {item.label}
                    </Typography>
                    {item?.subTexts?.length && (
                      <>
                        {item.subTexts.map((subItem) => (
                          <Typography
                            variant="body2"
                            sx={{
                              fontFamily: "Outfit, sans-serif",
                              fontWeight: 400,
                              fontSize: "12px",
                              color: "#4B5563",
                            }}
                          >
                            {subItem.label}: <strong>₹ {subItem.value}</strong>
                          </Typography>
                        ))}
                      </>
                    )}
                  </>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>}
      </Box>
      {
        isPopup && (
          <LeaseListPopUp
            header={header}
            open={isPopup}
            handleClose={handleClose}
            filter={status}
          />
        )
      }

      {
        isDealPopup && (
          <DealsListPopUp
            header={header}
            open={isDealPopup}
            handleClose={handleDealClose}
          />
        )
      }
    </>
  );
};

export default LeaseKpi;
